import { FleetService } from '../services/';

const namespace = 'fleet';

export const FETCHING_TRACKERS = `${namespace}/FETCHING_TRACKERS`;
export const TRACKERS_RECEIVED = `${namespace}/TRACKERS_RECEIVED`;
export const FETCHING_TRACKER = `${namespace}/FETCHING_TRACKER`;
export const TRACKER_RECEIVED = `${namespace}/TRACKER_RECEIVED`;

export const FETCHING_UNITS = `${namespace}/FETCHING_UNITS`;
export const UNITS_RECEIVED = `${namespace}/UNITS_RECEIVED`;

export const FETCHING_TRAILERS = `${namespace}/FETCHING_TRAILERS`;
export const TRAILERS_RECEIVED = `${namespace}/TRAILERS_RECEIVED`;

export const SAVING_UNIT = `${namespace}/SAVING_UNIT`;
export const UNIT_SAVED = `${namespace}/UNIT_SAVED`;
export const SAVING_TRAILER = `${namespace}/SAVING_TRAILER`;
export const TRAILER_SAVED = `${namespace}/TRAILER_SAVED`;

export const ASSIGNING_TRACKER = `${namespace}/ASSIGNING_TRACKER`;
export const TRACKER_ASSIGNED = `${namespace}/TRACKER_ASSIGNED`;

const fetchingTrackers = () => {
  return {
    type: FETCHING_TRACKERS
  }
}

const trackersReceived = (trackers) => {
  return {
    type: TRACKERS_RECEIVED,
    trackers
  }
}

export const getTrackers = () => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(fetchingTrackers());
    return FleetService.getTrackers(state.auth.auth).then(trackers => dispatch(trackersReceived(trackers)));
  }
}

const fetchingTracker = () => {
  return {
    type: FETCHING_TRACKER
  }
}

const trackerReceived = (tracker) => {
  return {
    type: TRACKER_RECEIVED,
    tracker
  }
}

export const getTracker = (id) => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(fetchingTracker());
    return FleetService.getTrackerInfo(state.auth.auth, id).then(tracker => dispatch(trackerReceived(tracker)));
  }
}

const fetchingUnits = () => {
  return {
    type: FETCHING_UNITS
  }
}

const unitsReceived = (units) => {
  return {
    type: UNITS_RECEIVED,
    units
  }
}

export const getUnits = () => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(fetchingUnits());
    return FleetService.getUnits(state.auth.auth).then(units => dispatch(unitsReceived(units)));
  }
}

const fetchingTrailers = () => {
  return {
    type: FETCHING_TRAILERS
  }
}

const trailersReceived = (trailers) => {
  return {
    type: TRAILERS_RECEIVED,
    trailers
  }
}

export const getTrailers = () => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(fetchingTrailers());
    return FleetService.getTrailers(state.auth.auth).then(trailers => dispatch(trailersReceived(trailers)));
  }
}

const savingUnit = () => {
  return {
    type: SAVING_UNIT
  }
}

const unitSaved = (unit) => {
  return {
    type: UNIT_SAVED,
    unit
  }
}

export const saveUnit = (values) => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(savingUnit());
    return FleetService.saveUnit(state.auth.auth, values)
    .then((unit) => { 
      return dispatch(unitSaved(unit));
    });
  }
}

const savingTrailer = () => {
  return {
    type: SAVING_TRAILER
  }
}

const trailerSaved = (unit) => {
  return {
    type: TRAILER_SAVED,
    unit
  }
}

export const saveTrailer = (values) => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(savingTrailer());
    return FleetService.saveTrailer(state.auth.auth, values)
    .then((unit) => {
      return dispatch(trailerSaved(unit))
    });
  }
}

const assigningTracker = () => {
  return {
    type: ASSIGNING_TRACKER
  }
}

const trackerAssigned = () => {
  return {
    type: TRACKER_ASSIGNED
  }
}

export const assignTracker = (id, values) => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(assigningTracker());
    return FleetService.assignTracker(state.auth.auth, id, values)
    .then(() => {
      return dispatch(trackerAssigned());
    });
  }
}


// WEBPACK FOOTER //
// ./src/actions/FleetActions.js